import definitions from "./black-schema-v1-2026-07-23.json" with { type: "json" };


export const schema = definitions.schema;
export const version = definitions.version;
export const generatedAt = definitions.generatedAt;
export const enums = definitions.enums;
export const classes = definitions.classes;

export { definitions };
export default classes;
